// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"VideoPlayer_playerWrapper__1NpVm","reactPlayer":"VideoPlayer_reactPlayer__2KPFL","playButton":"VideoPlayer_playButton__TlQKv"};